<template>
    <div class="baseinfo">
        <mt-header :title="title" class="fixedtop">
            <mt-button icon="back" slot="left" @click.native='$router.push("/certification")'></mt-button>
        </mt-header>
        <div class="infobody">
            <div class="titlebox" style="padding:10px 20px;">
                <div class="line"></div>
                <h1>基本信息</h1>
            </div>
            <div class="container">
                <div class="photo">
                    <p>头像<span style="color:red;font-weight:bold">*</span></p>
                    <img :src="portraitYrl" alt="" style="width:100px;height:100px;" @click="upPortraitBtn" v-if="portraitYrl">
                    <div v-else  class="addImg" @click="upPortraitBtn">
                        <van-icon name="plus" />
                        <p>点击上传</p>
                    </div>
                    <input id="upDataPart" type="file" accept="image/*" ref="upPortrait" @change="portraitChange($event)"/>
                </div>
                <div class="dataGroup">
                    <p>选择入驻类型<span style="color:red;font-weight:bold">*</span></p>
                    <div style="display: flex;justify-content:flex-end;align-items:center;" class="dataGroupdiv">
                        <van-field readonly clickable style="border:0"  placeholder="" @click="typeShow" input-align="right" v-model="form.enterType"/>
                        <van-icon name="arrow" @click="typeShow" />
                    </div>
                </div>
                <div class="dataGroup">
                    <p>职位头衔<span style="color:red;font-weight:bold">*</span></p>
                    <van-field  placeholder="输入您的职位" v-model="form.position" maxlength="15"/>
                </div>
                <div class="dataGroup">
                    <p>职位类型<span style="color:red;font-weight:bold">*</span></p>
                    <div style="display: flex;justify-content:flex-end;align-items:center;width:70%;">
                        <div>
                            <p class="positionname" v-for="(item,index) in selectposition" :key="index">
                                {{item.name}}
                                <van-icon name="cross" @click="delposition(item)"/>
                            </p>
                        </div>
                        <van-icon name="arrow" @click="positionShow" />
                    </div>
                </div>
                <div class="dataGroup">
                    <p>工作经验<span style="color:red;font-weight:bold">*</span></p>
                    <div style="display: flex;justify-content:flex-end;align-items:center;" class="dataGroupdiv">
                        <van-field readonly clickable  placeholder="" @click="workShow" input-align="right" v-model="form.experience"/>
                        <van-icon name="arrow" @click="workShow" />
                    </div>
                </div>
                <div class="dataGroup">
                    <p>日薪<span style="color:red;font-weight:bold">*</span></p>
                    <van-field  placeholder="8小时日薪" type="digit" pattern="[0-9]*" v-model="form.salary" maxlength="5"/>
                </div>
                <div class="dataGroup">
                    <p>所在城市<span style="color:red;font-weight:bold">*</span></p>
                    <div style="display: flex;justify-content:flex-end;align-items:center;" class="dataGroupdiv">
                        <van-field readonly clickable  placeholder="" @click="cityShow" input-align="right" v-model="form.city"/>
                        <van-icon name="arrow" @click="cityShow" />
                    </div>
                </div>
                <div class="dataGroup">
                    <p>性别<span style="color:red;font-weight:bold">*</span></p>
                    <div style="display: flex;justify-content:flex-end;align-items:center;" class="dataGroupdiv">
                        <van-field readonly clickable  placeholder="" @click="sexShow" input-align="right" v-model="form.sex"/>
                        <van-icon name="arrow" @click="sexShow" />
                    </div>
                </div>
                <div style="height:57px;"></div>
            </div>
            <div class="next">
                <van-button type="info" @click="save">下一步</van-button>
            </div>
        </div>
        <!-- 入驻类型 -->
        <van-popup v-model="pickType" position="bottom">
            <van-picker show-toolbar :columns="intype" @confirm="onintypeConfirm" @cancel="pickType = false"/>
        </van-popup>
        <!-- 工作经验 -->
        <van-popup v-model="pickWork" position="bottom">
            <van-picker show-toolbar :columns="worktype" @confirm="onworkConfirm" @cancel="pickWork = false"/>
        </van-popup>
        <!-- 所在城市 -->
        <van-popup v-model="pickcity" position="bottom">
            <van-picker show-toolbar :columns="citytype" @confirm="oncityConfirm" @cancel="pickcity = false"/>
        </van-popup>
        <!-- 性别 -->
        <van-popup v-model="picksex" position="bottom">
            <van-picker show-toolbar :columns="sextype" @confirm="onsexConfirm" @cancel="picksex = false"/>
        </van-popup>
        <!-- 头像剪裁 -->
        <div class="cut" v-show="portraitShow">
            <div class="cutBtn">
                <mt-button type="primary" size="small" @click="configPart()">完成</mt-button>
                <mt-button type="default" size="small" @click="canclePart()">取消</mt-button>
            </div>
            <vueCropper ref="cropper" :img="portraitUrl" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"   :autoCrop="true" :fixedBox="true" :fixed="option.fixed" :fixedNumber="option.fixedNumber"  :outputSize="0.8"></vueCropper>
        </div>
        <!-- 职位类型-->
        <van-popup v-model="pickposition" position="bottom">
            <mt-header title="选择职位类型">
                <van-icon name="cross" @click.native="onClose" slot="right"/>
            </mt-header>
            <div class="skilldiv">
                <div v-for="(item,index) in positionArr" :key="index">
                    <p>{{item.value}}</p>
                    <ul class="label_val">
                        <li v-for="(itemchildren,index) in item.children"  ref="skillsName" @click="toggle(itemchildren)" :key="index" :class="{select: itemchildren.active === '1'}">
                            <span>{{itemchildren.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn">
                <van-button type="info" @click="saveposition">保存</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
import vueCropper from 'vue-cropper'
export default {
    name: 'my',
    components: {
        vueCropper,
    },
    data(){
        return{
            title:'个人信息',
            form:{},
            httpurl:'',
            // 入驻类型
            pickType: false,
            intype:[],
            //工作经验
            pickWork:false,
            worktype:[],
            //所在城市
            pickcity:false,
            citytype:[],
            //性别
            picksex:false,
            sextype:[{id:1,text:'男'},{id:2,text:'女'}],
            // 头像
            // 显示隐藏剪裁div
            portraitShow: false,
            // 头像上传的本地路径
            portraitUrl: '',
            // 剪裁后图路径（base64）建议将这个路径和后台取到的反显路径写在一个变量中
            // portraitYrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAMAAADyQNAxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAw9pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjIzQzg1QjYzRDJFMTFFN0FCOUZGREEyMURDOUFENDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjIzQzg1QjUzRDJFMTFFN0FCOUZGREEyMURDOUFENDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0iNEE0RjNEMEM0N0NBRERDMUQ0OEU4QzAzQzYzRDg4MUUiIHN0UmVmOmRvY3VtZW50SUQ9IjRBNEYzRDBDNDdDQUREQzFENDhFOEMwM0M2M0Q4ODFFIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+ybVWkQAAAmRQTFRFc3hvzMTRzMTPc3pxcnhvcnduzsXRysLPysTPzMXRdHpxysLO4NTmzsXTzsTRc3hx08nYZGxh28/gzMLPaG9kcnhuZ25j3dPi1szbZ21ianFnYmld2c/f39TkbXNp2c7fZW1h4NbnaG5k0cnWcXdt3dPkzMXPY2pecXdu3dHiz8fU08rY29HgZW1ibHNobHJoaW9lanFl0cfUZWxi4tbn4NbmycLOoZ6gY2pf1MrZZW5ibHJndHtyZGpfZGxfcndvz8XTcnpx4NTn1MzbmpiadHtxzsTTzMXTbHNncXRqnp2epKGkdntyuLS61s7b08fU08nWb3dteH50eH52wLjEmpiYqaesgIN/5tjrp6SpZ25iv7jC39TmYWdbaG5jrKmv4tjnnZudmpqazMLRdHhydHpy2M/fX2VaXmVaY2xeen93bnZqen53XmdbX2db0cfWaW9knp2hkZSRgoaAkZGQ29Piraqtl5SX59ntmJSYg4aC1s7d5NbpmJeYnZ2enp2ge4B639PkfoB6fIB6m5qbb3Ztc3hukJCOaXFkbXRphomE0cnYxL3HlJeSeHx0oJ2gtK201MrbZGphkZKQ2dHfb3Zqvbe/4tjph4mGanJn0crWoKCeiouLpqOnc3tytbC4ycLK1MrYlJeUkpSRXWRakJKObXJpx7/KbnRqiYqJ39PmfH56cXZue3942M7dkJGOmpqYqampY2xfuLK9npublJKSkpCR4tbpg4SCz8fTZW5jkpSS5Njpb3Nsenx3c3duoaChmJSXanJor6qwYWhdfoB739TiiYmHqaSpt7K43dHgc3dvpYHgNAAAA1NJREFUeNpkUwXTHEUQ7Z6Znd293dPP3TXu7u4uRIhAEgiSQAQiEHd3dxdIIMSFQBz+VLpn7q6+qmzV9fbsvOt5/eY1oEB+tBCcCIyOTyT6c0Zr/mQi8EpTqmntYeGs33VXPBBWMEpYLHoChIsaXVdoLYIlXa6t27lp4m+P9szsUhPQRo7LB3gemIM8DkGPgm7PD/YsLm+X+2f7v8paudrnjZhPtRDrLQXR3LT8u7ZD4gqkjJTP/mdDf8PYsAV0fXM+ulVnFtVKBSBBQaT2+/ehi7YDIZi9jnKo2fVt/v9UCMCE/L3jajTaxjWxFz7m0KruVXUecCVw6AVbi+YU+EjsbS0XrSgD5yXziJJUkiKB+84PkVCa6QAaNPqxpos9uQYYZvQUHSrgnlhHZBT6tIq1vpSfwSiG5d9JaXMtzCtNUET/u/8EnCx7xym6koryprbaixjVcnXZL0lFKFCK2CvH6fTjCo1BFoVMUtSHv1b2U1KaM5l9cnMY41q+z+zt/Wusm5rLsjOGA7QZFTIZNkuaFws8dvLtI2C0lwMI1/jvuZS5Oqz3kHlZg0TXLCtyiJjDQTmfv0k0W+MI4uWxcNwChiNfg+pnUNRAyb6BhCD7CMxxjV5kP3pdGLqgQ0b7+PAvv+ihMW1kUhV9K50IHv5RGWc9ucXkD53NX8ljyI52LYZ+iZOL28W5PSl3jA4KBWaMj6BdYUeDws2f+ihJggJUbitIe9Ngje8Z5ZPvf/6sQVnt+wxeS8SH0UCgr1l7YYaHBA4Whsfbp9n3elGY6kq9e5a17ZGhHeeWnp7Bd83XI6tvHJ6eCPgM6y+GiWiq86D9t7o7cdZe0U2p5PqVzc+aHgsv7UJXFFZVjJmysVMutNAeqr+eNPjDoKrSaA7xct3SY+e7rT5RstSRJDqh2D+mhQ4lxdPuHn1bJwLoWLb7aV733EbJsrf0PVs2b3tDr3f3wlbQ+mVxQ3nviHWLeRiQDXJC3zarKuDU5bYRcp6yU0gnWvNTpvhgGuBvvnoAI64bvs6n4W8OvFl7FbZEzDhwEemYzJTi0U1nKtIIklAycpZDb8sezDdr7ghT42CqWL+nh1FK24QNpg9QAzKEs+8se9sNt8FWsYpLp4X2mcyEjwIMAADZaW81usJWAAAAAElFTkSuQmCC',
            portraitYrl:'',
            option:{
                autoCropWidth:300,
                autoCropHeight:300,
                fixedNumber:[1,1],
                fixed:true,
                fixedBox:false,
            },
            // 职位类型
            pickposition:false,
            positionArr:[],
            selectposition:[],
            selectpositionname:[],
            position:[],
            // 性别
            sex:''
        }
    },
    created(){
        this.$emit('footer', false);
        this.datainfo();
    },
    methods:{
        // 职位类型
        positionShow(){
            this.pickposition = true
        },
        onClose(){
            this.pickposition = false
        },
        // 入驻类型
        typeShow(){
            this.pickType = true
        },
        onintypeConfirm(v) {
            this.form.enterType=v.text
            this.pickType = false;
        },
        // 工作经验
        workShow(){
            this.pickWork=true;
        },
        onworkConfirm(value){
            this.form.experience=value.text
            this.pickWork=false
        },
        //所在城市
        cityShow(){
            this.pickcity=true;
        },
        oncityConfirm(value){
            this.form.city=value.text
            this.pickcity=false
        },
        //性别
        sexShow(){
            this.picksex=true;
        },
        onsexConfirm(value){
            this.form.sex=value.text
            this.picksex=false
        },
        // 图片上传
        canclePart: function () {
            document.getElementById('upDataPart').value=''
            this.portraitShow = false
        },
        upPortraitBtn: function () {
            this.$refs.upPortrait.click()
        },
        portraitChange: function (e) {
            let _this = this
            var fil = e.target.files[0]
            var reader = new FileReader()
            reader.readAsDataURL(fil)
            reader.onload = function () {
                _this.portraitUrl = reader.result
            }
            this.portraitShow = true
        },
        // 上传头像
        configPart: function () {
            let _this = this
            _this.$refs.cropper.getCropData((data) => {
                _this.portraitYrl = data
                _this.portraitShow = false
                let param = new FormData()
                param.append('img', _this.portraitYrl)
                _this.axios({
                    method: 'post',
                    url: '/url/user/uploadAvatar',
                    timeout: 100000,
                    data: param
                }).then(function (response) {
                    if (response.data.success) {
                        _this.form.photo = response.data.data.id
                        document.getElementById('upDataPart').value=''
                    } else {
                        document.getElementById('upDataPart').value=''
                    }
                }).catch(function (response) {
                    document.getElementById('upDataPart').value=''
                })
            })
        },
        datainfo(){
            let _this = this
            function httpUrl () {
                return _this.axios.get('url/user/imgHttpUrl.json')
            }
            function userInfomationById () {
                return _this.axios.get('url/userName/getUserInformation?accountId='+sessionStorage.getItem('loginId'))
            }
            function loadSelect () {
                return _this.axios.get('url/account/userInfo/vueGetInfomationData')
            }
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })
            _this.axios.all([httpUrl(),userInfomationById(),loadSelect()])
                .then(_this.axios.spread(function (imgurl, userInfo, load) {
                    Indicator.close()
                    _this.httpurl=imgurl.data
                     _this.positionArr=load.data.positionTypeList
                    if (userInfo.data.photo !== null) {
                        _this.portraitYrl = imgurl.data + userInfo.data.photo
                    }
                    _this.form=userInfo.data
                    _this.form.photo=userInfo.data.photoId
                    _this.form.city = userInfo.data.cityName
                    _this.form.experience=userInfo.data.experienceName
                    _this.form.enterType=userInfo.data.enterTypeName
                    if(userInfo.data.sex===0){
                        _this.form.sex='男'
                    }else if(userInfo.data.sex===null){
                        _this.form.sex=''
                    }else{
                        _this.form.sex='女'
                    }
                    load.data.enterTypeList[0].children.forEach((item,index) => {
                        _this.intype.push({id:index,text: item})
                    });
                    load.data.workExperienceList[0].children.forEach((item,index) => {
                        _this.worktype.push({id:index,text: item})
                    });
                    load.data.city[0].children.forEach((item,index) => {
                        _this.citytype.push({id:index,text: item})
                    });
                    // 职位类型反显
                    if (userInfo.data.positionTypeName !== null && userInfo.data.positionTypeName !== '') {
                        _this.position = userInfo.data.positionTypeName.split(',')
                        if (_this.position != null && _this.position.length > 0) {
                            for (var i = 0; i < _this.positionArr.length; i++) {
                                for (var j = 0; j < _this.positionArr[i].children.length; j++) {
                                    for (var k = 0; k < _this.position.length; k++) {
                                        if (_this.positionArr[i].children[j].name === _this.position[k]) {
                                            _this.positionArr[i].children[j].active = '1'
                                            _this.selectposition.push(_this.positionArr[i].children[j])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }))
        },
        save(){
            let _this = this
            var positionName=''
            if (_this.selectposition.length > 0) {
                for (var i = 0; i < _this.selectposition.length; i++) {
                    if ((i + 1) < _this.selectposition.length) {
                        positionName += _this.selectposition[i].id + ','
                    } else {
                        positionName += _this.selectposition[i].id
                    }
                }
            }
            if(_this.form.photo===''||_this.form.photo===undefined||_this.form.photo===null){
                 Toast({
                    message: '请上传头像',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.enterType===''||_this.form.enterType===undefined){
                 Toast({
                    message: '请选择入驻类型',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.position===''||_this.form.position===undefined||_this.form.position===null){
                 Toast({
                    message: '请输入职位头衔',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(positionName===''||positionName===undefined){
                 Toast({
                    message: '请选择职位类型',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.experience===''||_this.form.experience===undefined){
                 Toast({
                    message: '请选择工作经验',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.salary===''||_this.form.salary===undefined){
                 Toast({
                    message: '请输入日薪',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.salary==='0'||_this.form.salary.indexOf('-')>-1){
                 Toast({
                    message: '请输入正确日薪',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.city===''||_this.form.city===undefined){
                 Toast({
                    message: '请选择所在城市',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.sex===''||_this.form.sex===undefined){
                 Toast({
                    message: '请选择性别',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.sex==='男'){
                _this.sex=0
            }else{
                _this.sex=1
            }
            _this.axios({
                method: 'POST',
                url: '/url/account/userInfo/vueUpdateUserInformation',
                timeout: 100000,
                data: {
                    photo:_this.form.photo,
                    enterType: _this.form.enterType,
                    position:_this.form.position,
                    positionType:positionName,
                    experience: _this.form.experience,
                    salary:_this.form.salary,
                    city: _this.form.city,
                    sex: _this.sex,
                    updateFlag:0,
                    accountId:sessionStorage.getItem('loginId')
                }
            }).then(function (res) {
                if(res.data.success){
                    _this.$router.push({path:'/skills'})
                }else{
                    Toast({
                        message: res.data.msg,
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                }
            }).catch(function (res) {
                Toast({
                    message: '编辑资料失败',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
            })
        },
        toggle(event){
            if(!event.active){
                if(this.selectposition.length>4){
                    Toast({
                        message: '最多选择5项',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                    return false
                }
                event.active='1'
                this.selectposition.push(event)
            }else if(event.active==='1'){
                event.active='0'
                if(this.selectposition.indexOf(event)>-1){
                    this.selectposition.splice(this.selectposition.indexOf(event),1)
                }
            }else{
                if(this.selectposition.length>4){
                    Toast({
                        message: '最多选择5项',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                    return false
                }
                event.active='1'
                this.selectposition.push(event)
            }
        },
        saveposition(){
            this.pickposition=false
        },
        delposition(item){
            item.active='0'
            this.selectposition.splice(this.selectposition.indexOf(item),1)
        }
    }
}
</script>

<style scoped>
    .fixedtop{
        position:fixed;
        top:0;
        width:100%;
        z-index:1000;
    }
    .infobody .titlebox{
        margin-top:40px;
    }
    .infobody .titlebox .line{
        width: 8px;
        height: 12px;
        background: #6ba5e0;
        display: inline-block;
    }
    .infobody h1{
        display:inline-block;
        font-weight: bold;
        font-size:15px;
    }
    .infobody .photo{
        padding:0 35px;
        border-bottom: 1px solid #ddd;
        display: flex;
        padding-bottom:13px;
    }
    .infobody .photo p{
        display: inline-block;
        margin-right: 10px;
        font-size:14px;
    }
    .infobody .photo .van-uploader{
        display: inline-block;
    }
    .infobody .dataGroup{
        border-bottom: 1px solid #ddd;
        padding:13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .infobody .dataGroup p{
        font-size:14px;
        display: inline-block;
    }
    .infobody .dataGroup .select{
        display: inline-block;
        float:right;
        font-size:15px;
    }
    .dataGroupdiv .van-cell{
        display: inline-block;
        width: 100%;
        padding: 0;
    }
    .van-cell{
        display: inline-block;
        width: 70%;
        padding: 0;
    }
    .next{
        position:fixed;
        text-align:center;
        bottom:0;
        background:#fff;
        width:100%;
        padding:10px 0;
    }
    .next .van-button{
        width:40%;
        height:37px;
        border-radius: 5px;
        color:#fff;
    }
    #upDataPart{
        display: none;
    }
    .cut{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1001;
        background-color: #fff;
    }
    .cut .cutBtn{
        padding: 5px 20px;
    }
    .skilldiv{
        /* margin-top:40px; */
        padding:0 10px;
    }
    .skilldiv p{

    }
    .label_val{
        padding:10px;
        overflow:hidden;
    }
    .label_val li{
        float:left;
        background:#d7d7d7;
        border:1px solid #d7d7d7;
        color:#685f56;
        border-radius:15px;
        -webkit-border-radius:15px;
        -moz-border-radius:15px;
        padding:2px 10px;
        margin:5px;
    }
    .select{
        background:#ccedfc!important;
        border:1px solid #ccedfc!important;
    }
    .van-popup .mint-header{
        text-align:center;
        width:100%;
        background:#fff;
        color:#000;
    }
    .btn{
        text-align: center;
    }
    .btn .van-button{
        width:40%;
        height:37px;
        border-radius: 5px;
        margin:0 0 10px;
    }
    .positionname{
        float: left;
        background: #ccedfc;
        border: 1px solid #ccedfc;
        color: #685f56;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        padding: 2px 10px;
        margin: 5px;
    }
    .addImg{
        width:100px;
        height:100px;
        border: 1px solid #ddd;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .addImg .van-icon{
        font-size:24px;
        color:#c3bfbf;
    }
    .addImg p{
        margin-right:0!important;
    }
</style>


// WEBPACK FOOTER //
// baseinfo.vue?e210b7e0